import React, { useState } from "react";
import VideoPopup from "../../common/Modals/VideoPopup";

const MaintenanceContractDetails = () => {
  const [isVideoOpen,setIsVideoOpen] = useState(false);
  return (
    <>
      <div className="tp-service-page pt-140 pb-140">
        <div className="container">
          <div className="row pb-30">
            <div className="col-lg-6 mb-30">
              <div className="tp-sv-inner-img w-img">
                <img src="/assets/img/service/Service-maintenance1.jpg" alt="" />
              </div>
            </div>
            <div className="col-lg-6 mb-30">
              <div className="tp-sv-inner-img w-img">
                <img src="/assets/img/service/Service-Maintenance2.jpg" alt="" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="tp-sv__content">
                <h3 className="tp-sv__title">Comprehensive Lift Maintenance Contracts</h3>
                <p>
                Lumetiq Elevators Pvt Ltd offers specialized lift maintenance contract 
                  services to ensure the smooth operation and longevity of your elevators. 
                  Our maintenance plans are tailored to minimize downtime and enhance safety.{" "}
                </p>

                <p>
                Our expert technicians perform regular inspections, preventive maintenance, 
                  and rapid troubleshooting to keep your elevators running efficiently. We 
                  prioritize compliance with industry safety standards and use high-quality 
                  replacement parts when needed.
                </p>

                <h4 className="tp-sv__subtitle">
                Reliable and Hassle-Free Maintenance
                </h4>
                <p>
                With our structured maintenance programs, you can avoid unexpected breakdowns 
                  and costly repairs. Our team is available for scheduled servicing as well as 
                  emergency support, ensuring uninterrupted elevator performance.
                </p>
                <p>
                Whether you own a residential, commercial, or industrial elevator, our 
                  maintenance contracts provide peace of mind with 24/7 support, regular 
                  servicing, and compliance with all safety regulations.
                </p>

                <p>
                Trust Lumetiq Elevators Pvt Ltd for expert maintenance solutions that 
                  extend the lifespan of your elevators and enhance passenger safety.
                </p>

                <div className="tp-sv__video">
                  <div
                    className="tp_sv__video-bg"
                    // data-background="/assets/img/service/service-blog-bg.jpg"
                    style={{
                      backgroundImage: `url("/assets/img/service/service-blog-bg.jpg")`,
                    }}
                  >
                    {/* <div className="pt-180 pb-180 text-center p-relative">
                      <span>
                        <button
                          onClick={()=> setIsVideoOpen(true)}
                          className="sv-video sv-popup-video"
                        >
                          <i className="fas fa-play"></i>
                        </button>
                      </span>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* video modal start */}
      <VideoPopup
        isVideoOpen={isVideoOpen}
        setIsVideoOpen={setIsVideoOpen}
        videoId={"EW4ZYb3mCZk"}
      />
      {/* video modal end */}
    </>
  );
};

export default MaintenanceContractDetails;
